import { Component, Input } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NotificationModel } from 'src/app/core/models/push/notification.model';
import { AuthMyfileService } from 'src/app/core/services/auth.myfile.service';
import { MyfileApiService } from 'src/app/core/services/myfile-api.service';
import { ToasterNotificationService } from 'src/app/core/services/toaster-notification.service';
import { BaseModalComponent } from '../base-modal/base-modal.component';

@Component({
  selector: 'app-notification-view-modal',
  templateUrl: './notification-view-modal.component.html',
  styleUrls: ['./notification-view-modal.component.scss']
})
export class NotificationViewModalComponent extends BaseModalComponent {

  disableModel: boolean = true;

  @Input() notification: NotificationModel = new NotificationModel();

  constructor(
    protected override myFileApiService: MyfileApiService,
    protected override authMyFileService: AuthMyfileService,
    protected override modalRef: NgbActiveModal,
    protected override toasterNotificationService: ToasterNotificationService,
    protected override sanitizer: DomSanitizer,
  ) {
    super(myFileApiService, authMyFileService, modalRef, toasterNotificationService, sanitizer);
  }

  override ngOnInit(): void {

  }

  override validate(): boolean {
    return true;
  }

  override onUpdate(): void {

  }
  
  override onCreate(): void {

  }

  ngOnDestroy(): void {
    this.notification = new NotificationModel();
  }

}
